namespace GeniuzPOS.Inventory {
    export class IcStockEomProcessingColumns {
        static columnsKey = 'Inventory.IcStockEomProcessing';
    }
}
